import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { fetchExcel } from 'actions/excelDownload'
import { fetchCapacitationsByFilter, resetCapacitationsByFilter } from 'actions/capacitations'
import { setSelectedCapacitation } from 'actions/selectedCapacitation'
import { setCapacitationDetailStatus } from 'actions/capacitationDetailStatus'
import { setSelectedSearchedItem, resetSelectedSearchedItem } from 'actions/selectedSearchedItem'
import { setEditPopupStatus } from 'actions/editPopup'
import { setDeletePopupStatus } from 'actions/deletePopup'
import { setSelectedCapacitationPage } from 'actions/page'

import { capitalizeFirstLetter } from 'utils/strings'

import { DivWrapperItems, DivWrapperError, DivWrapperLoader } from './styled'

import i18n from 'services/i18n'

import Loader from 'components/Loaders/propagate'
import MaterialExpansionPanel from 'components/ExpansionPanel'
import CapacitationPreview from 'components/CapacitationPreview'
import Pagination from 'components/Pagination'

import filterKeys from 'constants/filterKeys'
import popupKeys from 'constants/popupKeys'

import { paginate } from 'utils/paginator'

class SearchDisplayCourse extends Component {
  state = {
    current: 1
  }
  componentDidUpdate = prevProps => {
    if (
      prevProps.selectedPage.capacitationPage !== this.props.selectedPage.capacitationPage &&
      this.props.selectedFilter.filterCategory === filterKeys.COURSE.COURSE_ID
    ) {
      this.getCapacitationsByCourseId(this.props.selectedSearchedItem.expandedItem)
    }
  }

  isFetching = () =>
    this.props.courses.isFetching ||
    this.props.courses.isFetchingByDate ||
    this.props.courses.isFetchingAll

  isCourseExpanded = id => this.props.selectedSearchedItem.expandedItem === id

  thereAreValues = () =>
    this.props.courses.values || this.props.courses.valuesByDate || this.props.courses.valuesAll

  getCapacitationsByCourseId = id => {
    if (this.isCourseExpanded(id) && id) {
      this.props.fetchCapacitationsByFilter(filterKeys.COURSE.COURSE_ID, id)
    }
  }

  setSelectedCourse = id => {
    if (this.isCourseExpanded(id)) {
      this.props.resetSelectedSearchedItem()
    } else {
      this.props.setSelectedSearchedItem({ id })
    }
  }

  wichCourseWasSelected = id => this.state.selectedCourseDownload === id

  handleCourse = id => {
    this.props.resetSelectedSearchedItem()
    this.props.resetCapacitationsByFilter()
    this.props.setSelectedCapacitationPage(1)

    this.setSelectedCourse(id)
    setTimeout(() => {
      this.getCapacitationsByCourseId(id)
    }, 40)
  }

  fetchExcel = (e, id, type, fileName) => {
    this.setState({ selectedCourseDownload: id })
    this.props.fetchExcel(id, type, fileName)
    e.stopPropagation()
  }

  handleCapacitationDetail = (e, capacitation) => {
    e.stopPropagation()
    this.props.setSelectedCapacitation(capacitation)
    this.props.setCapacitationDetailStatus(
      this.props.capacitationDetailStatus.status ? false : true
    )
  }

  onChangePagination = page => {
    this.setState({
      current: page
    })
  }

  handleEditPopup = (e, item, type) => {
    this.props.setEditPopupStatus({ open: true, itemToEdit: item, type: type })
    e.stopPropagation()
  }

  handleDelete = (e, item, type) => {
    this.props.setDeletePopupStatus({ open: true, itemToDelete: item, type: type })
    e.stopPropagation()
  }

  wichValues = () =>
    this.props.courses.values ? this.props.courses.values : this.hasCapacitations()

  hasCapacitations = () => {
    if (
      this.props.selectedDateFilter.filterDateFrom &&
      this.props.selectedDateFilter.filterDateTo &&
      this.props.courses.valuesByDate
    ) {
      return this.props.courses.valuesByDate.filter(e => e.hasTrainings)
    } else {
      return this.props.courses.valuesAll
    }
  }

  render() {
    if (this.isFetching()) {
      return <Loader />
    } else {
      return this.thereAreValues() ? (
        this.wichValues().length ? (
          <DivWrapperItems>
            {paginate(this.state.current, this.wichValues()).map(item => (
              <MaterialExpansionPanel
                key={item.id}
                name={item.name}
                id={item.id}
                expanded={this.isCourseExpanded(item.id)}
                onClick={() => this.handleCourse(item.id)}
                withDownload={true}
                onButtonDownloadClick={e =>
                  this.fetchExcel(e, item.id, filterKeys.COURSE.COURSE_ID, item.name)
                }
                buttonDownloadLoading={
                  this.props.excelDownload.isFetching && this.wichCourseWasSelected(item.id)
                }
                withEdit
                onButtonEditClick={e => this.handleEditPopup(e, item, popupKeys.COURSE)}
                withDelete
                onButtonDeleteClick={e => this.handleDelete(e, item, popupKeys.COURSE)}
                hasCapacitations={item['hasTrainings']}
              >
                <div>
                  {this.props.capacitations.isFetching ? (
                    <DivWrapperLoader>
                      <Loader />
                    </DivWrapperLoader>
                  ) : this.props.capacitations.values &&
                    this.props.capacitations.values.items.length ? (
                    <CapacitationPreview
                      onClick={(e, capacitation) => this.handleCapacitationDetail(e, capacitation)}
                      data={this.props.capacitations.values ? this.props.capacitations.values : ''}
                      onDeleteClick={(e, capacitation) =>
                        this.handleDelete(e, capacitation, popupKeys.CAPACITATION)
                      }
                    />
                  ) : (
                    <DivWrapperError>
                      {capitalizeFirstLetter(`${i18n('HOME').HOME_PAGE_NO_CAPACITATIONS}`)}
                    </DivWrapperError>
                  )}
                </div>
              </MaterialExpansionPanel>
            ))}
            <Pagination
              total={this.wichValues().length}
              isLocal={true}
              onChangeLocal={this.onChangePagination}
              selectedPageLocal={this.state.current}
            />
          </DivWrapperItems>
        ) : (
          <DivWrapperError>
            {capitalizeFirstLetter(`${i18n('SEARCH').SEARCH_NO_DATA}`)}
          </DivWrapperError>
        )
      ) : (
        <DivWrapperError>{capitalizeFirstLetter(`${i18n('SEARCH').SEARCH_ERROR}`)}</DivWrapperError>
      )
    }
  }
}

const mapStateToProps = ({
  courses,
  capacitations,
  excelDownload,
  capacitationDetailStatus,
  selectedSearchedItem,
  selectedDateFilter,
  selectedPage,
  selectedFilter
}) => ({
  courses,
  capacitations,
  excelDownload,
  capacitationDetailStatus,
  selectedSearchedItem,
  selectedDateFilter,
  selectedPage,
  selectedFilter
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCapacitationsByFilter,
      fetchExcel,
      setSelectedCapacitation,
      setCapacitationDetailStatus,
      setSelectedSearchedItem,
      resetSelectedSearchedItem,
      resetCapacitationsByFilter,
      setEditPopupStatus,
      setDeletePopupStatus,
      setSelectedCapacitationPage
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchDisplayCourse)
